import React, { useState, useEffect, useRef } from 'react';
import clsx  from 'clsx';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { useStyles } from './LanguageSwitcherStyles';
import { Us, De, Nl, Fr, Hu, Gr, Id, Ru, Tr, Pl, Hr, Pt, Es, It, Hk, Cn } from '../UI/svg/languageIcons/flags';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const _languageIcons = {
	en: Us,
	de: De,
	nl: Nl,
	fr: Fr,
	hu: Hu,
	el: Gr,
	id: Id,
	ru: Ru,
	tr: Tr,
	pl: Pl,
	hr: Hr,
	pt: Pt,
	es: Es,
	it: It,
	'zh-tc': Hk,
	'zh-cn': Cn
};

function LanguageSwitcher({ classes, i18n, languages, onChangeLanguage }) {
	const [isOpened, handleToggleMenu] = useState(false);
	const menuRef = useRef(null);
	const language = languages.filter(l => l.lang === i18n.resolvedLanguage)[0] || {};

	useEffect(() => {
		function hideMenu(event) {
			if (menuRef.current && !menuRef.current.contains(event.target)) {
				handleToggleMenu(false);
			}
		}

		document.addEventListener('mousedown', hideMenu);
		return () => {
			document.removeEventListener('mousedown', hideMenu);
		};
	}, [menuRef]);

	const toggleMenu = () => {
		handleToggleMenu(!isOpened);
	};

	const handleChangeLanguage = (l) => {
		cookies.set('userLang', l, { path: '/', domain: (window.location.hostname || '').split('signup.')[1], secure: true });
		onChangeLanguage(l);
		handleToggleMenu(false);
	};

	const renderIcon = lang => {
		const TagName = _languageIcons[lang];
		return _languageIcons[lang] ? <TagName /> : null;
	};

	return (
		<div className={clsx(classes.switcherContainer)} ref={menuRef}>
			<div className={clsx(classes.menuBtn, {[classes.menuBtnActive]: isOpened})} onClick={toggleMenu}>
				<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="pi pi-globe" viewBox="0 0 16 16">
					<path
						d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm6.77 7.4h-1.69c-.12-2.1-.85-3.76-1.58-4.91-.12-.18-.23-.36-.35-.51 2 1.05 3.41 3.06 3.61 5.42h.01Zm-8.3-5.53c.13-.14.24-.25.31-.31.04-.03.06-.06.08-.07l.02-.02.25-.21c.28-.04.57-.05.87-.05.3 0 .58.02.87.05l.25.21.02.02c.02.02.05.04.08.07.07.07.18.17.31.31.26.28.61.71.96 1.27a9.03 9.03 0 0 1 1.39 4.27H4.12a9.07 9.07 0 0 1 1.39-4.27c.35-.56.7-.98.96-1.27Zm-1.63.11c-.11.16-.23.33-.35.51A10.23 10.23 0 0 0 2.91 7.4H1.22a6.816 6.816 0 0 1 3.61-5.42h.01ZM1.23 8.6h1.69c.12 2.1.85 3.76 1.58 4.91.12.18.23.36.35.51-2-1.05-3.41-3.06-3.61-5.42h-.01Zm8.3 5.53c-.13.14-.24.25-.31.31-.04.03-.06.06-.08.07l-.02.02-.25.21c-.28.04-.57.05-.87.05-.3 0-.58-.02-.87-.05l-.25-.21-.02-.02s-.05-.04-.08-.07c-.07-.07-.18-.17-.31-.31-.26-.28-.61-.71-.96-1.26A9.03 9.03 0 0 1 4.12 8.6h7.76a9.07 9.07 0 0 1-1.39 4.27c-.35.56-.7.98-.96 1.26Zm1.63-.11c.11-.16.23-.33.35-.51a10.23 10.23 0 0 0 1.58-4.91h1.69a6.816 6.816 0 0 1-3.61 5.42h-.01Z"/>
				</svg>
				<span>{language.name}</span>
			</div>
			<div className={classes.dropdown}>
				<ul className={classes.languagesList}>
					{languages.filter(l => l.lang !== i18n.resolvedLanguage).map((l, i) => {
						return (
							<li key={i} onClick={() => handleChangeLanguage(l.lang)}>
								{renderIcon(l.lang)}<span>{l.name}</span>
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
}

LanguageSwitcher.propTypes = {
	V3: PropTypes.bool,
	i18n: PropTypes.object,
	classes: PropTypes.object,
	languages: PropTypes.array,
	onChangeLanguage: PropTypes.func
};

export default withStyles(useStyles)(withNamespaces()(LanguageSwitcher));